module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("storevideos", [["div",{"class":"site-page store-videos no-pb"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title","data-fox-alias":"storeTitle"},[["p",{},[["textNode",{"text":"Shop"}]]]]],["div",{"class":"tags-filter"}]]]]],["section",{"class":"store-list-wrapper"},[["div",{"class":"content-grid store-grid store-block-1"}],["div",{"class":"break-row "}],["div",{"class":"content-grid store-grid store-block-2"}],["div",{"class":"break-row "}],["div",{"class":"content-grid store-grid store-block-3"}]]],["div",{"class":"pager-wrapper"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!./components/store/templates/storeVideos.tpl
// module id = 512
// module chunks = 4